import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import ImpactHero, { heroImgStyles } from '~components/ImpactHero';
import { ConstrainedText } from '~components/Text';
import Infographic from '~components/Infographic';

// Page Navigation
import PageNav from '~components/PageNav';
import VirtualFundraisingCard from '~components/PageCard/FundraisingCard';

import Bear from '~components/Svg/Bear';
import GradCap from '~components/Svg/GradCap';
import Podium from '~components/Svg/Podium';
import T1DSquare from '~components/Svg/T1DSquare';

const CommunityPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Communauté" desc="Description" />
      <ImpactHero title="Communauté">
        <StaticImage style={heroImgStyles} src="../../images/community.jpg" alt="" />
      </ImpactHero>
      <div tw="container">
        <div tw="grid gap-6 lg:(grid-cols-2 gap-12)">
          <Infographic
            icon={<GradCap tw="text-blue h-36 w-auto" />}
            title="Lancées en septembre 2020"
          >
            Lancées en septembre 2020, les séries de discussions virtuelles ont permis de créer des liens entre des personnes inscrites dans plus de 80 communautés uniques au Canada, grâce à un soutien par les pairs, offert en ligne et qui a pu desservir des régions rurales et éloignées. 
          </Infographic>
          <Infographic icon={<Bear tw="text-blue h-36 w-auto" />} title="673">
          673 Canadiens nouvellement diagnostiqués ont reçu un sac de l’espoir de FRDJ par l’entremise d’un centre d’enseignement sur le diabète. Chaque trousse contient du matériel d’information sur le DT1, des ressources, et Rufus, l’ours diabétique.
          </Infographic>
          <Infographic icon={<T1DSquare tw="text-blue h-36 w-auto" />} title="853">
          Lancement de Parlons DT1, une nouvelle série éducative qui permet à des experts de partout au pays de rencontrer la communauté des personnes atteintes du DT1, grâce à une série d’activités éducatives virtuelles et de rencontres communautaires, rassemblant 853 personnes participantes.
          </Infographic>
          <Infographic icon={<Podium tw="text-blue h-36 w-auto" />} title="232">
          En 2020, FRDJ a engagé 232 jeunes ambassadeurs des quatre coins du Canada. Les jeunes ambassadeurs partagent leurs histoires personnelles afin de sensibiliser les Canadiens à la vie avec le DT1. 
          </Infographic>
        </div>
        <ConstrainedText tw="text-4xl">
        Merci à tous ceux qui ont contribué à faire {' '}
          <strong>de 2020 une année fructueuse et marquante pour FRDJ Canada.</strong>.
        </ConstrainedText>
        <PageNav previous={<VirtualFundraisingCard />} />
      </div>
    </Layout>
  );
};

export default CommunityPage;
